var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagotipoEthics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 115,
    viewBox: "0 0 127 115",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.57 31.144c6.742 0 12.224 5.505 12.224 12.34 0 6.793-5.482 12.307-12.223 12.307-6.741 0-12.193-5.514-12.193-12.308 0-6.834 5.452-12.339 12.193-12.339zm0 65.41L18.389 44.12 53.571 74.54l42.56-43.2C86.492 18.03 70.802 9.363 53.067 9.363 23.762 9.363 0 33.008 0 62.182 0 91.355 23.762 115 53.068 115c29.307 0 53.064-23.645 53.064-52.818 0-9.385-2.47-18.19-6.78-25.825L53.571 96.554zM127 0 96.13 31.338a51.905 51.905 0 0 1 3.223 5.019L127 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagotipoEthics);
export default __webpack_public_path__ + "static/media/imagotipo-ethics.3ab7da52ae5c7a60d9a573f4b3cb6ccb.svg";
export { ForwardRef as ReactComponent };